import axios from "axios";
import config from "config";

const mock = require("../mock/config/configure");

const baseURL = config.api.host;
let instance;

export default {
  create: () => {
    const lang = document.querySelector("html").getAttribute("lang");
    instance = axios.create({
      baseURL,
      headers: {
        "Accept-Language": lang,
      },
    });
  },
  mock: () => {
    mock.default(instance);
  },
  instance: () => {
    return instance;
  },
};



// WEBPACK FOOTER //
// ./src/api/config/connection.js